import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth/auth.guard';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './error-pages/page-not-found/page-not-found.component';
import { UserBlockedComponent } from './error-pages/user-blocked/user-blocked.component';
import { BusinessSelectorComponent } from './home/business-selector/business-selector.component';
import { BusinessGuard } from './auth/business.guard';
import { ActiveUserResolver } from './auth/active-user.resolver';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' }, // this fucking sheet
  { path: 'login', component: LoginComponent },
  {
    path: 'home',
    canActivate: [AuthGuard],
    resolve: {
      activeUser: ActiveUserResolver,
    },
    children: [
      {
        path: '',
        component: BusinessSelectorComponent,
      },
      {
        path: ':business',
        canActivate: [BusinessGuard],
        component: HomeComponent,
        data: { breadcrumb: 'business' },
      },
    ],
  },
  { path: 'blocked', component: UserBlockedComponent },
  { path: 'not-found', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
